"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VarFilosofi() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="45481" id="vår-filosofi" ref={ref} className="bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-[100px]" />
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-primary/3 rounded-full blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className={cn("flex flex-col lg:flex-row items-center gap-12 lg:gap-20 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="w-full lg:w-7/12 relative group perspective-1000">
            <div className="relative transform transition-transform duration-700 hover:scale-[1.01] hover:rotate-1">
              {}
              <div className="relative rounded-lg overflow-hidden shadow-xl rotate-2 border border-border bg-card">
                <img alt="Exklusiv badrumsdesign" className="w-full h-auto object-cover aspect-[4/3] brightness-100 contrast-100" src="https://proffsbadrum.se/wp-content/uploads/2026/09/Intro.BIld_.webp" />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none z-20" />
              </div>

              {}
              <div className="absolute -top-6 -right-4 z-30">
                <Badge variant="outline" className="bg-background/90 backdrop-blur-md border-primary/30 text-primary px-4 py-1.5 text-sm font-default">
                  Premium
                </Badge>
              </div>
            </div>
          </div>

          {}
          <div className="hidden lg:flex h-80 items-center justify-center">
            <Separator orientation="vertical" className="h-full w-[1px] bg-gradient-to-b from-transparent via-primary/50 to-transparent opacity-40" />
          </div>

          {}
          <div className="w-full lg:w-5/12 space-y-8 text-left">
            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl font-default font-semibold tracking-tight text-foreground">Badrumsrenovering i Värmland med kvalitet i <span className="text-primary/90">varje detalj</span></h2>
              <div className="h-1 w-20 bg-primary/20 rounded-full" />
            </div>

            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed font-default">
              <p>
                Vi kompromissar aldrig med utförandet. För oss handlar en badrumsrenovering om mer än bara yta; det handlar om precision i varje tätskikt, noggrannhet i plattsättningen och ett öga för de små detaljerna som gör den stora skillnaden.
              </p>
              <p>När du vill renovera badrum i Värmland hjälper vi dig att kombinera funktion med material och design som passar både bostaden och dina önskemål. Det kan handla om allt från kakel och klinker till duschlösningar, badkar, kommod, blandare och golvvärme.</p>
              <p>Genom att kombinera gedigen hantverkskunskap med moderna metoder skapar vi badrum med hög kvalitet i både utförande och detaljer. Varje projekt behandlas som ett unikt hantverk, skapat för att ge dig en känsla av exklusivitet och trygghet i ditt hem.</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}